<template>
    <div>
        <!-- 标题 -->
        <div class="case-title">
            <Row>
                <Col span="12">
                    <Breadcrumb>
                        <BreadcrumbItem>{{$t('Bill.RI.title')}}</BreadcrumbItem>
                    </Breadcrumb>
                </Col>
                <Col span="12">
                    <Select v-model="stateSearchKey" filterable placeholder="" style="width: 150px;float: right;margin-top: -7px;" @on-change="searchRegion(stateSearchKey)">
                        <Option v-for="item in regionList" :value="item.regionType" v-bind:key="item.id">{{ item.name }}</Option>
                    </Select>
                </Col>
            </Row>
        </div>
        <Row :gutter="16">
            <!-- 实例 -->
            <Col span="12">
                <Card :padding="8">
                    <Row>
                        <Col class="title">{{$t('Bill.RI.currentRIList')}}</Col>
                        <Col>
                            <Icon type="ios-cloud-download-outline" class="download" @click="exportTableCurrentBudgetInstanceList"/>
                        </Col>
                    </Row>
                    <!-- 当前预留实例列表 -->
                    <Table :no-data-text="$t('common.noData')" class="table-css" height="400" :columns="tableCurrentBudgetInstanceListColumns" :data="tableCurrentBudgetInstanceListDate" size="small" @on-row-dblclick="tableCurrentBudgetInstanceListDetail" :loading="tableCurrentBudgetInstanceListLoadings"> </Table>
                    <!-- 当前预留实例列表详情 -->
                    <Modal v-model="tableCurrentBudgetInstanceListModal" :title="$t('Bill.RI.detail')"  :mask-closable="false" width="800px">
                        <Table :no-data-text="$t('common.noData')" class="table-css" height="400" :columns="tableCurrentBudgetInstanceListColumnDetail" :data="tableCurrentBudgetInstanceListDetailDate" size="small" :loading="tableCurrentBudgetInstanceListLoading"></Table>
                        <div slot="footer">
                            <Button type="info" @click="exportTableCurrentBudgetInstanceListDetail">导出</Button>
                            <Button type="text" size="large" @click="tableCurrentBudgetInstanceListCaseReset">{{ $t('alarms.common.cancel') }}</Button>
                        </div>
                    </Modal>
                </Card>
            </Col>
            <Col span="12">
                <Card :padding="8">
                    <Row>
                        <Col class="title">{{$t('Bill.RI.reservedInstanceReccmd')}}</Col>
                        <Col>
                            <Icon type="ios-cloud-download-outline" class="download" @click="exportTableReservedInstanceRecommendation"/>
                        </Col>
                    </Row>
                    <!-- 预留实例推荐 -->
                    <Table :no-data-text="$t('common.noData')" class="table-css" height="400" :columns="tableReservedInstanceRecommendationColumns" :data="tableReservedInstanceRecommendationDate" size="small" @on-row-dblclick="tableReservedInstanceRecommendationDetail" :loading="tableReservedInstanceRecommendationLoadings"> </Table>
                    <!-- 预留实例推荐详情 -->
                    <Modal v-model="tableReservedInstanceRecommendationModal" :title="$t('Bill.RI.detail')"  :mask-closable="false" width="800px">
                        <Table :no-data-text="$t('common.noData')" class="table-css" height="400" :columns="tableReservedInstanceRecommendationColumnDetail" :data="tableReservedInstanceRecommendationDetailDate" size="small" :loading="tableReservedInstanceRecommendationLoading"></Table>
                        <div slot="footer">
                            <Button type="info" @click="exportTableReservedInstanceRecommendationDetail">导出</Button>
                            <Button type="text" size="large" @click="tableReservedInstanceRecommendationCaseReset">{{ $t('alarms.common.cancel') }}</Button>
                        </div>
                    </Modal>
                </Card>
            </Col>
        </Row>
        <Row :gutter="16">
            <Col span="12">
                <Card :padding="8">
                    <Row>
                        <Col class="title">{{$t('Bill.RI.otherReservedList')}}</Col>
                        <Col>
                            <Icon type="ios-cloud-download-outline" class="download" @click="exportTableAllList"/>
                        </Col>
                    </Row>
                    <!-- 当前预留RDS,预留ElastiCache,预留Redshift,预留ElastiSearch等列表 -->
                    <Table :no-data-text="$t('common.noData')" class="table-css" height="400" :columns="tableAllListColumns" :data="tableAllListDate" size="small" @on-row-dblclick="tableAllListDetail" :loading="tableAllListLoadings"></Table>
                    <!-- 当前预留RDS,预留ElastiCache,预留Redshift,预留ElastiSearch等列表详情 -->
                    <Modal v-model="tableAllListModal" :title="$t('Bill.RI.detail')" :mask-closable="false" width="800px">
                        <Table :no-data-text="$t('common.noData')" class="table-css" height="400" :columns="tableAllListColumnDetail" :data="tableAllListDetailDate" size="small" :loading="tableAllListLoading"></Table>
                        <div slot="footer">
                            <Button type="info" @click="exportTableAllListDetail">导出</Button>
                            <Button type="text" size="large" @click="tableAllListCaseReset">{{ $t('alarms.common.cancel') }}</Button>
                        </div>
                    </Modal>
                </Card>
            </Col>
            <Col span="12">
                <Card :padding="8">
                    <Row>
                        <Col class="title">{{$t('Bill.RI.DHHostReservedInstance')}}</Col>
                        <Col>
                            <Icon type="ios-cloud-download-outline" class="download" @click="exportTableHost"/>
                        </Col>
                    </Row>
                    <!-- DH Host预留实例 -->
                    <Table :no-data-text="$t('common.noData')" class="table-css" height="400" :columns="tableHostColumns" :data="tableHostDate" size="small" @on-row-dblclick="tableHostDetail" :loading="tableHostLoadings"></Table>
                    <!-- DH Host预留实例详情 -->
                    <Modal v-model="tableHostModal" :title="$t('Bill.RI.detail')" :mask-closable="false" width="800px">
                        <Table :no-data-text="$t('common.noData')" class="table-css" height="400" :columns="tableHostColumnDetail" :data="tableHostDetailDate" size="small" :loading="tableHostLoading"></Table>
                        <div slot="footer">
                            <Button type="info" @click="exportTableHostDetail">导出</Button>
                            <Button type="text" size="large" @click="tableHostCaseReset">{{ $t('alarms.common.cancel') }}</Button>
                        </div>
                    </Modal>
                </Card>
            </Col>
        </Row>
        <Row :gutter="16">
            <Col span="12">
                <Card :padding="8">
                    <Row>
                        <Col class="title">{{$t('Bill.RI.proEnvInstanceStatus')}}</Col>
                        <Col>
                            <Icon type="ios-cloud-download-outline" class="download" @click="exportTableProductionEnvironmentExample"/>
                        </Col>
                    </Row>
                    <!-- 生产环境实例情况 -->
                    <Table :no-data-text="$t('common.noData')" class="table-css" height="400" :columns="tableProductionEnvironmentExampleColumns" :data="tableProductionEnvironmentExampleDate" size="small" @on-row-dblclick="tableProductionEnvironmentExampleDetail" :loading="tableProductionEnvironmentExampleLoadings"></Table>
                    <!-- 生产环境实例情况详情 -->
                    <Modal v-model="tableProductionEnvironmentExampleModal" :title="$t('Bill.RI.detail')"  :mask-closable="false" width="800px">
                        <Table :no-data-text="$t('common.noData')" class="table-css" height="400" :columns="tableProductionEnvironmentExampleColumnDetail" :data="tableProductionEnvironmentExampleDetailDate" size="small" :loading="tableProductionEnvironmentExampleLoading"></Table>
                        <div slot="footer">
                            <Button type="info" @click="exportTableProductionEnvironmentExampleDetail">导出</Button>
                            <Button type="text" size="large" @click="tableProductionEnvironmentExampleCaseReset">{{ $t('alarms.common.cancel') }}</Button>
                        </div>
                    </Modal>
                </Card>
            </Col>
            <Col span="12">
                <Card :padding="8">
                    <Row>
                        <Col class="title">{{$t('Bill.RI.devEnvInstanceStatus')}}</Col>
                        <Col>
                            <Icon type="ios-cloud-download-outline" class="download" @click="exportTableDevelopmentEnvironmentInstance"/>
                        </Col>
                    </Row>
                    <!-- 开发环境实例情况 -->
                    <Table :no-data-text="$t('common.noData')" class="table-css" height="400" :columns="tableDevelopmentEnvironmentInstanceColumns" :data="tableDevelopmentEnvironmentInstanceDate" size="small" @on-row-dblclick="tableDevelopmentEnvironmentInstanceDetail" :loading="tableDevelopmentEnvironmentInstanceLoadings"> </Table>
                    <!-- 开发环境实例情况详情 -->
                    <Modal v-model="tableDevelopmentEnvironmentInstanceModal" :title="$t('Bill.RI.detail')"  :mask-closable="false" width="800px">
                        <Table :no-data-text="$t('common.noData')" class="table-css" height="400" :columns="tableDevelopmentEnvironmentInstanceColumnDetail" :data="tableDevelopmentEnvironmentInstanceDetailDate" size="small" :loading="tableDevelopmentEnvironmentInstanceLoading"></Table>
                        <div slot="footer">
                            <Button type="info" @click="exportTableDevelopmentEnvironmentInstanceDetail">导出</Button>
                            <Button type="text" size="large" @click="tableDevelopmentEnvironmentInstanceCaseReset">{{ $t('alarms.common.cancel') }}</Button>
                        </div>
                    </Modal>
                </Card>
            </Col>
        </Row>

    </div>
</template>

<script>
    var tableBillingVue = {};
    export default {
        name: 'RIPage',
        data () {
            return {
                stateSearchKey:'北京',
                regionList:[{
                    id:0,
                    name:this.$t('Bill.RI.beijing'),
                    regionType:'北京'
                },{
                    id:1,
                    name:this.$t('Bill.RI.Singapore'),
                    regionType:'Singapore'
                }],
                // 当前预留实例列表
                instanceTypeTableCurrentBudgetInstanceList:'',
                instanceSystemTableCurrentBudgetInstanceList:'',
                quantityTableCurrentBudgetInstanceList:'',
                tableCurrentBudgetInstanceListModal:false,
                tableCurrentBudgetInstanceListLoading: false,
                tableCurrentBudgetInstanceListLoadings: false,
                tableCurrentBudgetInstanceListColumns: [
                    {
                        title: this.$t('alarms.common.scanType'),
                        key: 'instanceType'
                    },
                    {
                        title: this.$t('Bill.RI.system'),
                        key: 'instanceSystem'
                    },
                    {
                        title: this.$t('Bill.RI.quantity'),
                        key: 'quantity'
                    },
                    {
                        title: this.$t('Bill.RI.startTime'),
                        key: 'startDate'
                    },
                    {
                        title: this.$t('Bill.RI.endTime'),
                        key: 'endDate'
                    }
                ],
                tableCurrentBudgetInstanceListColumnDetail: [
                    {
                        title: 'rowNum',
                        key: 'rowNum'
                    },
                    {
                        title: 'awsId',
                        key: 'awsId'
                    },
                    {
                        title: 'awsName',
                        key: 'awsName'
                    },
                    {
                        title: 'id',
                        key: 'id'
                    },
                    {
                        title: this.$t('alarms.common.scanType'),
                        key: 'instanceType'
                    },
                    {
                        title: this.$t('Bill.RI.quantity'),
                        key: 'quantity'
                    }
                ],
                tableCurrentBudgetInstanceListDate:[],
                tableCurrentBudgetInstanceListDetailDate:[],
                // 预留实例推荐
                instanceTypeTableReservedInstanceRecommendation:'',
                instanceSystemTableReservedInstanceRecommendation:'',
                rentModeTableReservedInstanceRecommendation:'',
                tableReservedInstanceRecommendationModal:false,
                tableReservedInstanceRecommendationLoading: false,
                tableReservedInstanceRecommendationLoadings: false,
                tableReservedInstanceRecommendationColumns: [
                    {
                        title: this.$t('Bill.RI.rent'),
                        key: 'rentMode'
                    },
                    {
                        title: this.$t('alarms.common.scanType'),
                        key: 'instanceType'
                    },
                    {
                        title: this.$t('Bill.RI.system'),
                        key: 'instanceSystem'
                    },
                    {
                        title: this.$t('Bill.RI.RIAmount'),
                        key: 'riRec'
                    }
                ],
                tableReservedInstanceRecommendationColumnDetail: [
                    {
                        title: this.$t('Bill.RI.rent'),
                        key: 'rentMode'
                    },
                    {
                        title: this.$t('alarms.common.scanType'),
                        key: 'instanceType'
                    },
                    {
                        title: this.$t('Bill.RI.system'),
                        key: 'instanceSystem'
                    },
                    {
                        title: this.$t('Bill.RI.RIAmount'),
                        key: 'riRec'
                    }
                ],
                tableReservedInstanceRecommendationDate:[],
                tableReservedInstanceRecommendationDetailDate:[],
                // DH Host预留实例
                linkedAccountIdTableHost:'',
                subScriptionIdTableHost:'',
                dhTypeTableHost:'',
                tableHostModal:false,
                tableHostLoading: false,
                tableHostLoadings: false,
                tableHostColumns: [
                    {
                        title: this.$t('Bill.RI.account'),
                        key: 'linkedAccountId'
                    },
                    {
                        title: this.$t('Bill.RI.subScriptionId'),
                        key: 'subScriptionId'
                    },
                    {
                        title: this.$t('alarms.common.scanType'),
                        key: 'dhType'
                    },
                    {
                        title: this.$t('Bill.RI.startTime'),
                        key: 'startDate'
                    },
                    {
                        title: this.$t('Bill.RI.due'),
                        key: 'endDate'
                    }
                ],
                tableHostColumnDetail: [
                    {
                        title: this.$t('Bill.RI.account'),
                        key: 'linkedAccountId'
                    },
                    {
                        title: this.$t('Bill.RI.subScriptionId'),
                        key: 'subScriptionId'
                    },
                    {
                        title: this.$t('alarms.common.scanType'),
                        key: 'dhType'
                    },
                    {
                        title: this.$t('Bill.RI.startTime'),
                        key: 'startDate'
                    },
                    {
                        title: this.$t('Bill.RI.due'),
                        key: 'endDate'
                    }
                ],
                tableHostDate:[],
                tableHostDetailDate:[],
                // 开发环境实例情况
                instanceSeriesTableDevelopmentEnvironmentInstance:'',
                instanceSystemTableDevelopmentEnvironmentInstance:'',
                tableDevelopmentEnvironmentInstanceModal:false,
                tableDevelopmentEnvironmentInstanceLoading: false,
                tableDevelopmentEnvironmentInstanceLoadings: false,
                tableDevelopmentEnvironmentInstanceColumns: [
                    {
                        title: this.$t('Bill.RI.system'),
                        key: 'instanceSystem'
                    },
                    {
                        title: this.$t('Bill.RI.series'),
                        key: 'instanceSeries'
                    },
                    {
                        title: this.$t('Bill.RI.quantity'),
                        key: 'ec2Amount'
                    }
                ],
                tableDevelopmentEnvironmentInstanceColumnDetail: [
                    {
                        title: this.$t('Bill.RI.system'),
                        key: 'instanceSystem'
                    },
                    {
                        title: this.$t('alarms.common.scanType'),
                        key: 'instanceSeries'
                    },
                    {
                        title: this.$t('Bill.RI.rent'),
                        key: 'rentMode'
                    },
                    {
                        title: this.$t('Bill.RI.instanceAmount'),
                        key: 'ec2Amount'
                    }
                ],
                tableDevelopmentEnvironmentInstanceDate:[],
                tableDevelopmentEnvironmentInstanceDetailDate:[],

                // 当前预留RDS,预留ElastiCache,预留Redshift,预留ElastiSearch等列表
                instanceTypeTableAllList:'',
                instanceSystemTableAllList:'',
                tableAllListModal:false,
                tableAllListLoading: false,
                tableAllListLoadings: false,
                tableAllListColumns: [
                    {
                        title: this.$t('alarms.common.scanType'),
                        key: 'instanceType'
                    },
                    {
                        title: this.$t('Bill.RI.system'),
                        key: 'instanceSystem'
                    },
                    {
                        title: this.$t('Bill.RI.quantity'),
                        key: 'quantity'
                    }
                    // {
                    //     title: this.$t('Bill.RI.startTime'),
                    //     key: 'start'
                    // },
                    // {
                    //     title: this.$t('Bill.RI.endTime'),
                    //     key: 'end'
                    // }
                ],
                tableAllListColumnDetail: [
                    {
                        title: this.$t('alarms.common.scanType'),
                        key: 'instanceType'
                    },
                    {
                        title: this.$t('Bill.RI.system'),
                        key: 'instanceSystem'
                    },
                    {
                        title: this.$t('Bill.RI.quantity'),
                        key: 'quantity'
                    }
                    // {
                    //     title: this.$t('Bill.RI.startTime'),
                    //     key: 'start'
                    // },
                    // {
                    //     title: this.$t('Bill.RI.endTime'),
                    //     key: 'end'
                    // }
                ],
                tableAllListDate:[],
                tableAllListDetailDate:[],
                 // 生产环境实例情况
                instanceSeriesTableProductionEnvironmentExample:'',
                instanceSystemTableProductionEnvironmentExample:'',
                tableProductionEnvironmentExampleModal:false,
                tableProductionEnvironmentExampleLoading: false,
                tableProductionEnvironmentExampleLoadings: false,
                tableProductionEnvironmentExampleColumns: [
                    {
                        title: this.$t('Bill.RI.system'),
                        key: 'instanceSystem'
                    },
                    {
                        title: this.$t('Bill.RI.series'),
                        key: 'instanceSeries'
                    },
                    {
                        title: this.$t('Bill.RI.instanceAmount'),
                        key: 'ec2Amount'
                    },
                    {
                        title: this.$t('Bill.RI.RIAmount'),
                        key: 'riQuantity'
                    }
                ],
                tableProductionEnvironmentExampleColumnDetail: [
                    {
                        title: this.$t('Bill.RI.system'),
                        key: 'instanceSystem'
                    },
                    {
                        title: this.$t('Bill.RI.series'),
                        key: 'instanceSeries'
                    },
                    {
                        title: this.$t('Bill.RI.rent'),
                        key: 'rentMode'
                    },
                    {
                        title: this.$t('Bill.RI.instanceAmount'),
                        key: 'ec2Amount'
                    },
                    {
                        title: this.$t('Bill.RI.RIAmount'),
                        key: 'riQuantity'
                    }
                ],
                tableProductionEnvironmentExampleDate:[],
                tableProductionEnvironmentExampleDetailDate:[]
            }
        },
        beforeCreate: function() {
            tableBillingVue = this
        },
        mounted:function(){
            tableBillingVue.init();
        },
        methods: {
            /************************按状态筛选***************************************/
            // 按状态筛选
            searchRegion: function(){
               tableBillingVue.init();
            },
            /************************所有表格***************************************/
            init:function(){
                tableBillingVue.listCurrentReservedInstance();
                tableBillingVue.listRecommendedReservedInstance();
                tableBillingVue.listDHHostReservedInstance();
                tableBillingVue.listDevEnvironmentReservedInstance();
                tableBillingVue.listNotEc2ReservedInstance();
                tableBillingVue.listProdEnvironmentReservedInstance();
            },
            /**********当前预留实例列表********************************************/
            listCurrentReservedInstance:function(){
                this.tableCurrentBudgetInstanceListLoadings = true;
                this.$api.billingRI.listCurrentReservedInstance({
                    "awsId":"896320650425",
                    "riState":"active",
                    "businessRegion":this.stateSearchKey
                })
                .then(res => {
                    this.tableCurrentBudgetInstanceListDate = res.data;
                    this.tableCurrentBudgetInstanceListLoadings = false;
                })
            },
             //详情页
            tableCurrentBudgetInstanceListDetail:function(row){
                // 内部导出传参
                this.instanceTypeTableCurrentBudgetInstanceList=row.instanceType;
                this.instanceSystemTableCurrentBudgetInstanceList=row.instanceSystem;
                this.quantityTableCurrentBudgetInstanceList=row.quantity;
                // 页面打开
                this.tableCurrentBudgetInstanceListModal=true;
                this.tableCurrentBudgetInstanceListLoading = true;
                this.$api.billingRI.listCurrentReservedInstance({
                    "awsId":"896320650425",
                    "riState":"active",
                    "businessRegion":this.stateSearchKey,
                    "instanceType":row.instanceType,
                    "instanceSystem":row.instanceSystem,
                    "quantity":row.quantity
                })
                .then(res => {
                    this.tableCurrentBudgetInstanceListDetailDate = res.data;
                    this.tableCurrentBudgetInstanceListLoading = false;
                })
            },
            //导出外部
            exportTableCurrentBudgetInstanceList: function () {
                this.$Message.loading({
                    duration: 0,
                    content: '正在导出，请稍等...'
                })
                // 下载Excel 文件
                this.$api.billingRI.exportBilling({
                    "awsId":"896320650425",
                    "riState":"active",
                    "businessRegion":this.stateSearchKey,
                    "exportType": 0,
                    "isExportDetail": false
                })
                .then(res => {
                    let fileName = '当前预留实例列表.xls'
                    let blob = new Blob([res.data], {type: 'application/x-xls'})
                    if (window.navigator.msSaveOrOpenBlob) {
                      navigator.msSaveBlob(blob, fileName);
                    } else {
                      var link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.download = fileName;
                      link.click();
                      window.URL.revokeObjectURL(link.href);
                    }
                    this.$Message.destroy();
                    this.$Message.success('导出成功');
                  })
            },
            //导出内部
            exportTableCurrentBudgetInstanceListDetail: function(){
                this.$Message.loading({
                    duration: 0,
                    content: '正在导出，请稍等...'
                })
                // 下载Excel 文件
                this.$api.billingRI.exportBilling({
                    "awsId":"896320650425",
                    "riState":"active",
                    "businessRegion":this.stateSearchKey,
                    "instanceType":this.instanceTypeTableCurrentBudgetInstanceList,
                    "instanceSystem":this.instanceSystemTableCurrentBudgetInstanceList,
                    "quantity":this.quantityTableCurrentBudgetInstanceList,
                    "exportType": 0,
                    "isExportDetail": true
                })
                .then(res => {
                    let fileName = '当前预留实例列表(详情).xls'
                    let blob = new Blob([res.data], {type: 'application/x-xls'})
                    if (window.navigator.msSaveOrOpenBlob) {
                      navigator.msSaveBlob(blob, fileName);
                    } else {
                      var link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.download = fileName;
                      link.click();
                      window.URL.revokeObjectURL(link.href);
                    }
                    this.$Message.destroy();
                    this.$Message.success('导出成功');
                })
            },

            // 取消
            tableCurrentBudgetInstanceListCaseReset:function(){
                this.tableCurrentBudgetInstanceListModal=false;
            },

            /**********预留实例推荐*************************************/
            listRecommendedReservedInstance:function(){
                this.tableReservedInstanceRecommendationLoadings = true;
                this.$api.billingRI.listRecommendedReservedInstance({
                    "businessRegion":this.stateSearchKey
                })
                .then(res => {
                    this.tableReservedInstanceRecommendationDate = res.data;
                    this.tableReservedInstanceRecommendationLoadings = false;
                })
            },
             //详情页
            tableReservedInstanceRecommendationDetail:function(row){
                // 内部导出传参
                this.instanceTypeTableReservedInstanceRecommendation=row.instanceType;
                this.instanceSystemTableReservedInstanceRecommendation=row.instanceSystem;
                this.rentModeTableReservedInstanceRecommendation=row.rentMode;
                // 页面打开
                this.tableReservedInstanceRecommendationModal=true;
                this.tableReservedInstanceRecommendationLoading = true;
                this.$api.billingRI.listRecommendedReservedInstance({
                    "businessRegion":this.stateSearchKey,
                    "instanceType":row.instanceType,
                    "instanceSystem":row.instanceSystem,
                    "rentMode":row.rentMode
                })
                .then(res => {
                    this.tableReservedInstanceRecommendationDetailDate = res.data;
                    this.tableReservedInstanceRecommendationLoading = false;
                })
            },
            //导出外部
            exportTableReservedInstanceRecommendation: function () {
                this.$Message.loading({
                    duration: 0,
                    content: '正在导出，请稍等...'
                })
                // 下载Excel 文件
                this.$api.billingRI.exportBilling({
                    "businessRegion":this.stateSearchKey,
                    "exportType": 1,
                    "isExportDetail": false
                })
                .then(res => {
                    let fileName = '预留实例推荐.xls'
                    let blob = new Blob([res.data], {type: 'application/x-xls'})
                    if (window.navigator.msSaveOrOpenBlob) {
                      navigator.msSaveBlob(blob, fileName);
                    } else {
                      var link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.download = fileName;
                      link.click();
                      window.URL.revokeObjectURL(link.href);
                    }
                    this.$Message.destroy();
                    this.$Message.success('导出成功');
                  })
            },
            //导出内部
            exportTableReservedInstanceRecommendationDetail: function(){
                this.$Message.loading({
                    duration: 0,
                    content: '正在导出，请稍等...'
                })
                // 下载Excel 文件
                this.$api.billingRI.exportBilling({
                    "businessRegion":this.stateSearchKey,
                    "instanceType":this.instanceTypeTableReservedInstanceRecommendation,
                    "instanceSystem":this.instanceSystemTableReservedInstanceRecommendation,
                    "rentMode":this.rentModeTableReservedInstanceRecommendation,
                    "exportType": 1,
                    "isExportDetail": true
                })
                .then(res => {
                    let fileName = '预留实例推荐(详情).xls'
                    let blob = new Blob([res.data], {type: 'application/x-xls'})
                    if (window.navigator.msSaveOrOpenBlob) {
                      navigator.msSaveBlob(blob, fileName);
                    } else {
                      var link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.download = fileName;
                      link.click();
                      window.URL.revokeObjectURL(link.href);
                    }
                    this.$Message.destroy();
                    this.$Message.success('导出成功');
                })
            },
            // 取消
            tableReservedInstanceRecommendationCaseReset:function(){
                this.tableReservedInstanceRecommendationModal=false;
            },

            /**********DH Host预留实例*************************************/
            listDHHostReservedInstance:function(){
                this.tableHostLoadings = true;
                this.$api.billingRI.listDHHostReservedInstance({
                    "businessRegion":this.stateSearchKey
                })
                .then(res => {
                    this.tableHostDate = res.data;
                    this.tableHostLoadings = false;
                })
            },
             //详情页
            tableHostDetail:function(row){
                // 内部导出传参
                this.linkedAccountIdTableHost=row.linkedAccountId;
                this.subScriptionIdTableHost=row.subScriptionId;
                this.dhTypeTableHost=row.dhType;
                // 页面打开
                this.tableHostModal=true;
                this.tableHostLoading = true;
                this.$api.billingRI.listDHHostReservedInstance({
                    "businessRegion":this.stateSearchKey,
                    "linkedAccountId":row.linkedAccountId,
                    "subScriptionId":row.subScriptionId,
                    "dhType":row.dhType
                })
                .then(res => {
                    this.tableHostDetailDate = res.data;
                    this.tableHostLoading = false;
                })
            },
            //导出外部
            exportTableHost: function () {
                this.$Message.loading({
                    duration: 0,
                    content: '正在导出，请稍等...'
                })
                // 下载Excel 文件
                this.$api.billingRI.exportBilling({
                    "businessRegion":this.stateSearchKey,
                    "exportType": 3,
                    "isExportDetail": false
                })
                .then(res => {
                    let fileName = 'DH Host预留实例.xls'
                    let blob = new Blob([res.data], {type: 'application/x-xls'})
                    if (window.navigator.msSaveOrOpenBlob) {
                      navigator.msSaveBlob(blob, fileName);
                    } else {
                      var link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.download = fileName;
                      link.click();
                      window.URL.revokeObjectURL(link.href);
                    }
                    this.$Message.destroy();
                    this.$Message.success('导出成功');
                  })
            },
            //导出内部
            exportTableHostDetail: function(){
                this.$Message.loading({
                    duration: 0,
                    content: '正在导出，请稍等...'
                })
                // 下载Excel 文件
                this.$api.billingRI.exportBilling({
                    "businessRegion":this.stateSearchKey,
                    "linkedAccountId":this.linkedAccountIdTableHost,
                    "subScriptionId":this.subScriptionIdTableHost,
                    "dhType":this.dhTypeTableHost,
                    "exportType": 3,
                    "isExportDetail": true
                })
                .then(res => {
                    let fileName = 'DH Host预留实例(详情).xls'
                    let blob = new Blob([res.data], {type: 'application/x-xls'})
                    if (window.navigator.msSaveOrOpenBlob) {
                      navigator.msSaveBlob(blob, fileName);
                    } else {
                      var link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.download = fileName;
                      link.click();
                      window.URL.revokeObjectURL(link.href);
                    }
                    this.$Message.destroy();
                    this.$Message.success('导出成功');
                })
            },
            // 取消
            tableHostCaseReset:function(){
                this.tableHostModal=false;
            },

            /**********开发环境实例情况*************************************/
            listDevEnvironmentReservedInstance:function(){
                this.tableDevelopmentEnvironmentInstanceLoadings=true;
                this.$api.billingRI.listDevEnvironmentReservedInstance({
                    "businessRegion":this.stateSearchKey
                })
                .then(res => {
                    this.tableDevelopmentEnvironmentInstanceDate = res.data;
                    this.tableDevelopmentEnvironmentInstanceLoadings=false;
                })
            },
             //详情页
            tableDevelopmentEnvironmentInstanceDetail:function(row){
                // 内部导出传参
                this.instanceSeriesTableDevelopmentEnvironmentInstance=row.instanceSeries;
                this.instanceSystemTableDevelopmentEnvironmentInstance=row.instanceSystem;
                // 页面打开
                this.tableDevelopmentEnvironmentInstanceModal=true;
                this.tableDevelopmentEnvironmentInstanceLoading = true;
                this.$api.billingRI.listDevEnvironmentReservedInstance({
                    "businessRegion":this.stateSearchKey,
                    "instanceSeries":row.instanceSeries,
                    "instanceSystem":row.instanceSystem
                })
                .then(res => {
                    this.tableDevelopmentEnvironmentInstanceDetailDate = res.data;
                    this.tableDevelopmentEnvironmentInstanceLoading = false;
                })
            },
            //导出外部
            exportTableDevelopmentEnvironmentInstance: function () {
                this.$Message.loading({
                    duration: 0,
                    content: '正在导出，请稍等...'
                })
                // 下载Excel 文件
                this.$api.billingRI.exportBilling({
                    "businessRegion":this.stateSearchKey,
                    "exportType": 5,
                    "isExportDetail": false
                })
                .then(res => {
                    let fileName = '开发环境实例情况.xls'
                    let blob = new Blob([res.data], {type: 'application/x-xls'})
                    if (window.navigator.msSaveOrOpenBlob) {
                      navigator.msSaveBlob(blob, fileName);
                    } else {
                      var link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.download = fileName;
                      link.click();
                      window.URL.revokeObjectURL(link.href);
                    }
                    this.$Message.destroy();
                    this.$Message.success('导出成功');
                  })
            },
            //导出内部
            exportTableDevelopmentEnvironmentInstanceDetail: function(){
                this.$Message.loading({
                    duration: 0,
                    content: '正在导出，请稍等...'
                })
                // 下载Excel 文件
                this.$api.billingRI.exportBilling({
                    "businessRegion":this.stateSearchKey,
                    "instanceSeries":this.instanceSeriesTableDevelopmentEnvironmentInstance,
                    "instanceSystem":this.instanceSystemTableDevelopmentEnvironmentInstance,
                    "exportType": 5,
                    "isExportDetail": true
                })
                .then(res => {
                    let fileName = '开发环境实例情况(详情).xls'
                    let blob = new Blob([res.data], {type: 'application/x-xls'})
                    if (window.navigator.msSaveOrOpenBlob) {
                      navigator.msSaveBlob(blob, fileName);
                    } else {
                      var link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.download = fileName;
                      link.click();
                      window.URL.revokeObjectURL(link.href);
                    }
                    this.$Message.destroy();
                    this.$Message.success('导出成功');
                })
            },
            // 取消
            tableDevelopmentEnvironmentInstanceCaseReset:function(){
                this.tableDevelopmentEnvironmentInstanceModal=false;
            },

            /**********当前预留RDS,预留ElastiCache,预留Redshift,预留ElastiSearch等列表***************/
            listNotEc2ReservedInstance:function(){
                this.tableAllListLoadings = true;
                this.$api.billingRI.listNotEc2ReservedInstance({
                    "businessRegion":this.stateSearchKey
                })
                .then(res => {
                    this.tableAllListDate = res.data;
                    this.tableAllListLoadings = false;
                })
            },
             //详情页
            tableAllListDetail:function(row){
                // 内部导出传参
                this.instanceTypeTableAllList=row.instanceType;
                this.instanceSystemTableAllList=row.instanceSystem;
                // 页面打开
                this.tableAllListModal=true;
                this.tableAllListLoading = true;
                this.$api.billingRI.listNotEc2ReservedInstance({
                    "businessRegion":this.stateSearchKey,
                    "instanceType":row.instanceType,
                    "instanceSystem":row.instanceSystem
                })
                .then(res => {
                    this.tableAllListDetailDate = res.data;
                    this.tableAllListLoading = false;
                })
            },
            //导出外部
            exportTableAllList: function () {
                this.$Message.loading({
                    duration: 0,
                    content: '正在导出，请稍等...'
                })
                // 下载Excel 文件
                this.$api.billingRI.exportBilling({
                    "businessRegion":this.stateSearchKey,
                    "exportType": 2,
                    "isExportDetail": false
                })
                .then(res => {
                    let fileName = '当前预留RDS,预留ElastiCache,预留Redshift,预留ElastiSearch等列表.xls'
                    let blob = new Blob([res.data], {type: 'application/x-xls'})
                    if (window.navigator.msSaveOrOpenBlob) {
                      navigator.msSaveBlob(blob, fileName);
                    } else {
                      var link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.download = fileName;
                      link.click();
                      window.URL.revokeObjectURL(link.href);
                    }
                    this.$Message.destroy();
                    this.$Message.success('导出成功');
                  })
            },
            //导出内部
            exportTableAllListDetail: function(){
                this.$Message.loading({
                    duration: 0,
                    content: '正在导出，请稍等...'
                })
                // 下载Excel 文件
                this.$api.billingRI.exportBilling({
                    "businessRegion":this.stateSearchKey,
                    "instanceType":this.instanceTypeTableAllList,
                    "instanceSystem":this.instanceSystemTableAllList,
                    "exportType": 2,
                    "isExportDetail": true
                })
                .then(res => {
                    let fileName = '当前预留RDS,预留ElastiCache,预留Redshift,预留ElastiSearch等列表(详情).xls'
                    let blob = new Blob([res.data], {type: 'application/x-xls'})
                    if (window.navigator.msSaveOrOpenBlob) {
                      navigator.msSaveBlob(blob, fileName);
                    } else {
                      var link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.download = fileName;
                      link.click();
                      window.URL.revokeObjectURL(link.href);
                    }
                    this.$Message.destroy();
                    this.$Message.success('导出成功');
                })
            },
            // 取消
            tableAllListCaseReset:function(){
                this.tableAllListModal=false;
            },

            /**********生产环境实例情况*************************************/
            listProdEnvironmentReservedInstance:function(){
                this.tableProductionEnvironmentExampleLoadings = true;
                this.$api.billingRI.listProdEnvironmentReservedInstance({
                    "businessRegion":this.stateSearchKey
                })
                .then(res => {
                    this.tableProductionEnvironmentExampleDate = res.data;
                    this.tableProductionEnvironmentExampleLoadings = false;
                })
            },
             //详情页
            tableProductionEnvironmentExampleDetail:function(row){
                // 内部导出传参
                this.instanceSeriesTableProductionEnvironmentExample=row.instanceSeries;
                this.instanceSystemTableProductionEnvironmentExample=row.instanceSystem;
                // 页面打开
                this.tableProductionEnvironmentExampleModal=true;
                this.tableProductionEnvironmentExampleLoading = true;
                this.$api.billingRI.listProdEnvironmentReservedInstance({
                    "businessRegion":this.stateSearchKey,
                    "instanceSeries":row.instanceSeries,
                    "instanceSystem":row.instanceSystem
                })
                .then(res => {
                    this.tableProductionEnvironmentExampleDetailDate = res.data;
                    this.tableProductionEnvironmentExampleLoading = false;
                })
            },
            //导出外部
            exportTableProductionEnvironmentExample: function () {
                this.$Message.loading({
                    duration: 0,
                    content: '正在导出，请稍等...'
                })
                // 下载Excel 文件
                this.$api.billingRI.exportBilling({
                    "businessRegion":this.stateSearchKey,
                    "exportType": 4,
                    "isExportDetail": false
                })
                .then(res => {
                    let fileName = '生产环境实例情况.xls'
                    let blob = new Blob([res.data], {type: 'application/x-xls'})
                    if (window.navigator.msSaveOrOpenBlob) {
                      navigator.msSaveBlob(blob, fileName);
                    } else {
                      var link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.download = fileName;
                      link.click();
                      window.URL.revokeObjectURL(link.href);
                    }
                    this.$Message.destroy();
                    this.$Message.success('导出成功');
                  })
            },
            //导出内部
            exportTableProductionEnvironmentExampleDetail: function(){
                this.$Message.loading({
                    duration: 0,
                    content: '正在导出，请稍等...'
                })
                // 下载Excel 文件
                this.$api.billingRI.exportBilling({
                    "businessRegion":this.stateSearchKey,
                    "instanceSeries":this.instanceSeriesTableProductionEnvironmentExample,
                    "instanceSystem":this.instanceSystemTableProductionEnvironmentExample,
                    "exportType": 4,
                    "isExportDetail": true
                })
                .then(res => {
                    let fileName = '生产环境实例情况(详情).xls'
                    let blob = new Blob([res.data], {type: 'application/x-xls'})
                    if (window.navigator.msSaveOrOpenBlob) {
                      navigator.msSaveBlob(blob, fileName);
                    } else {
                      var link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.download = fileName;
                      link.click();
                      window.URL.revokeObjectURL(link.href);
                    }
                    this.$Message.destroy();
                    this.$Message.success('导出成功');
                })
            },
            // 取消
            tableProductionEnvironmentExampleCaseReset:function(){
                this.tableProductionEnvironmentExampleModal=false;
            }
        }
    }
</script>

<style scoped>
    .case-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 0px 4px;
        font-weight: 600;
    }
    .title
    {
        font-size:13px;
        font-weight: 600;
        padding: 10px;
        float:left;
    }
     .ivu-col-span-12
    {
        margin-bottom: 20px;
    }
    .download
    {
        float: right;
        margin-top: 11px;
        margin-bottom: 10px;
        font-size: 17px;
        margin-right: 4px;
        font-weight: 600;
        cursor: pointer;
    }
    /* 滚动条 */
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background: #ccc;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-track {
        background: #eeeeef;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-corner {
        background-color: #eeeeef;
    }
    .table-css >>> .ivu-table-overflowX{
        overflow-x: hidden !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/ebilling/ri_page/RIPage.vue